import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Tag } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function OfferAndGuarantee() {
  return <section className="py-24 px-4 relative" data-id="element-54">
      <div className="max-w-4xl mx-auto space-y-12" data-id="element-55">
        {/* Offer Box */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-b from-dark-lighter to-dark-card p-8 md:p-12 rounded-3xl border border-whatsapp/30 relative overflow-hidden text-center" data-id="element-56">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gradient-to-r from-transparent via-whatsapp to-transparent" data-id="element-57" />

          <Tag className="w-12 h-12 text-whatsapp mx-auto mb-6" data-id="element-58" />

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-59">
            Oferta Irresistible
          </h2>

          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-60">
            Sabemos que abril es un mes de supervivencia. El valor real de esta
            ingeniería es de{' '}
            <span className="line-through text-red-400" data-id="element-61">$197 USD</span>. Pero
            hoy, para ayudarte a recuperar tu tiempo y tu flujo de caja:
          </p>

          <div className="bg-dark p-6 rounded-2xl border border-dark-border inline-block mb-8" data-id="element-62">
            <p className="text-sm text-whatsapp font-bold uppercase tracking-wider mb-2" data-id="element-63">
              Acceso Instantáneo por solo
            </p>
            <div className="text-5xl md:text-7xl font-extrabold text-white mb-2" data-id="element-64">
              $27
              <span className="text-2xl md:text-3xl text-gray-400" data-id="element-65">
                .00 USD
              </span>
            </div>
            <p className="text-gray-400 text-sm" data-id="element-66">
              (Pago único. Acceso de por vida)
            </p>
          </div>

          <div data-id="element-67">
            <CTAButton data-id="element-68" />
          </div>
        </motion.div>

        {/* Guarantee Box */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col md:flex-row items-center gap-8 p-8 bg-dark-lighter rounded-2xl border border-dark-border" data-id="element-69">
          <div className="shrink-0" data-id="element-70">
            <ShieldCheck className="w-20 h-20 text-whatsapp" data-id="element-71" />
          </div>
          <div data-id="element-72">
            <h3 className="text-2xl font-bold mb-3" data-id="element-73">
              Garantía de Inmunidad Total
            </h3>
            <p className="text-gray-400 text-lg" data-id="element-74">
              Si en 7 días no sientes que has recuperado el control de tu
              WhatsApp y eliminado el estrés, te devuelvo cada centavo. Quédate
              con el Kit.{' '}
              <strong className="text-white" data-id="element-75">Yo asumo todo el riesgo.</strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}